import type { MusicService } from '@banger/shared';
import { detectRole, roleOverride, type Role } from './device';

const ROLE_KEY = 'banger.role';
const PLAYER_KEY = 'banger.playerId';
const HOST_KEY = 'banger.host';
const SERVICE_KEY = 'banger.service';

export interface HostSession { code: string; hostToken: string; service?: MusicService }

function get(k: string): string | null {
  try { return localStorage.getItem(k); } catch { return null; }
}
function set(k: string, v: string): void {
  try { localStorage.setItem(k, v); } catch { /* private mode */ }
}

export function playerId(): string {
  let id = get(PLAYER_KEY);
  if (!id) { id = crypto.randomUUID(); set(PLAYER_KEY, id); }
  return id;
}

export function loadHost(): HostSession | null {
  try {
    const h = JSON.parse(get(HOST_KEY) ?? 'null') as HostSession | null;
    return h && typeof h.code === 'string' && typeof h.hostToken === 'string' ? h : null;
  } catch { return null; }
}
export function clearHost(): void {
  try { localStorage.removeItem(HOST_KEY); } catch { /* */ }
}
export function saveHost(h: HostSession): void { set(HOST_KEY, JSON.stringify(h)); }

/** The music service the host picked last (Apple Music until they pick). */
export function lastService(): MusicService {
  return get(SERVICE_KEY) === 'spotify' ? 'spotify' : 'apple';
}
export function rememberService(s: MusicService): void { set(SERVICE_KEY, s); }

/** Role for `/`: ?as= override (persisted), then stored, then device detection. */
export function resolveRole(search: string): Role {
  const o = roleOverride(search, get(ROLE_KEY));
  if (o) { set(ROLE_KEY, o); return o; }
  return detectRole({
    userAgent: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints,
    coarsePointer: matchMedia('(pointer: coarse)').matches,
    screenWidth: screen.width,
  });
}

/** Switch link target: sets ?as= (resolveRole stores it on load). */
export function switchHref(to: Role): string {
  return `/?as=${to === 'display' ? 'host' : 'player'}`;
}
